import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M24.99 20.98c-.26 0-.51-.1-.71-.29L16 12.41l-8.29 8.28a.996.996 0 1 1-1.41-1.41l8.99-8.98a.996.996 0 0 1 1.41 0l8.99 8.98a.996.996 0 0 1-.7 1.7" }, null, -1)
  ]))]))
}
export default { render: render }